export enum LocalStorageEnum {
  Mensajes = "mensajes",
  Tooltips = "tooltips",
  Ligas = "ligas",
}
